import { flow, toPairs, forEach, isFunction } from 'lodash/fp';
import createLoader from './createLoader';
import createItemReducer from './createItemReducer';

const applyLoaders = (reducer, loaders) =>
  flow(
    toPairs,
    forEach(([name, options]) => {
      if (isFunction(options)) {
        options = { fetch: options };
      }

      const set = options.set || reducer.set;

      reducer[name] = createLoader({ ...options, set });
    }),
  )(loaders);

export default (name, defaultState, { loaders = {} } = {}) => {
  const reducer = createItemReducer(defaultState, name);

  if (!name) {
    throw new Error("A duck's name should be defined!");
  }

  if (loaders) {
    applyLoaders(reducer, loaders);
  }

  return reducer;
};
